/* ============================================================
   RANCANGAN KALENDAR → FACEBOOK (Bahagian 4, 2026-09-16)

   Bahagian TULEN (tiada React, tiada Firestore) daripada "Run Facebook baca
   kalendar", dikeluarkan dari WorkspaceView supaya boleh diuji dalam Node.
   Pemanggilnya (`handleRunFacebookKalendar` dalam WorkspaceView.jsx) hanya
   menjaga state + mesej ke extension.

   Keputusan user (12–16 Sept):
   · Run Facebook di tab Schedule membaca SLOT KALENDAR yang ditick — sama
     seperti Run TikTok. Set diambil daripada slot, bukan Control Panel.
   · Pagar Facebook lebih ketat daripada TikTok (diukur hidup 8 Sept):
     jadual mesti ≥ ~30 minit ke depan dan ≤ ~29 hari; pilihan masa FB
     setiap 5 minit (padan LANGKAH_MINIT slot SESAAT).
   · "Post sekarang" = SATU video sahaja (lebih → sekat + beritahu).
   · Caption FB: `captionFb` kalau diisi, kalau tidak jatuh ke caption TikTok —
     KECUALI pelanggan sengaja mengosongkannya (`captionFbKosong`, 27 Sept) → tanpa caption.

   ⚠️ BENTUK PAYLOAD ditentukan oleh extension (background.ts DIRECT_FACEBOOK_POST):
     products[i] = { id, name, shopeeLink, videos:{setN:url}, captions:{setN:teks},
                     jadual:{setN:'YYYY-MM-DDTHH:mm'}, sets:[setN…] }
     targetSets = senarai set; tetapan = { mode, aiLabel }.
     Robot mengulang SEMUA `targetSets` pada SETIAP produk dan menanda
     "gagal — tiada video" untuk set yang tiada dalam `videos`.

   ⛔ EXTENSION 3.9.4 (dilepaskan 16 Sept 21:18) TIDAK mengenali medan `sets`
      (penapis per-produk hanya masuk background.ts SELEPAS ZIP dibungkus).
      Jadi payload DIPECAH ikut "tanda tangan set": semua produk dalam satu
      kumpulan mempunyai set yang SAMA TEPAT → targetSets kumpulan itu tidak
      pernah menyentuh set yang produk itu tidak jadualkan. Lazimnya satu
      kumpulan sahaja; bila lebih, pemanggil menghantar satu demi satu dan
      extension menyusun giliran (`robotMulaAtauBeratur`). Medan `sets` tetap
      dihantar untuk extension akan datang.
   ============================================================ */

export const HAD_MINIT_FB = 30;   // FB tolak jadual < ~30 minit ke depan (diukur 2026-09-08)
export const HAD_HARI_FB = 29;    // ≈29–30 hari ke depan (diukur 2026-09-08)
export const LANGKAH_MINIT_FB = 5;

/* Caption yang dihantar ke Facebook: kotak FB kalau diisi, kalau tidak caption
   TikTok. Dipakai KEDUA-DUA laluan (tick kad + kalendar) — satu takrifan.
   ★ [2026-09-27] Keputusan user: pelanggan yang SENGAJA mengosongkan kotak FB dalam
   Edit prompts (`captionFbKosong: true`) → '' → robot FB melangkau langkah caption dan
   post tanpa caption (skrip 1.4.0 sudah begitu; semakan senarai Scheduled/Drafts
   dilangkau kerana tiada caption untuk dicari). Butiran: utils/captionKad.js. */
export function captionUntukFb(set) {
    const fb = String(set?.captionFb || '').trim();
    if (fb) return fb;
    if (fbKosongSengaja(set)) return '';
    return String(set?.captionTiktok || '');
}

/* Pelanggan SENGAJA memilih FB tanpa caption (bukan sekadar belum diisi). */
export function fbKosongSengaja(set) {
    return !String(set?.captionFb || '').trim() && set?.captionFbKosong === true;
}

/* ★ [2026-09-27] Nama fail reel yang robot terima (`task.filename`) — satu-satunya pengenal
   per-tugasan yang sampai ke skrip FB tanpa ZIP baharu. Dipakai untuk senarai
   `tetapan.captionKosongSengaja`, supaya log robot "[Tetapan pelanggan]" menulis bahawa
   pelanggan SENDIRI memilih post tanpa caption (arahan user 27 Sept).
   ⚠️ KEMBAR: background.ts DIRECT_FACEBOOK_POST (`filename: …_${setKey}.mp4`). Rumus itu
   berubah → padanan gagal → log hanya menulis "TIADA" (reel tetap dipost tanpa caption). */
export function namaFailReelFb(nama, setKey) {
    return `${String(nama || 'reel').replace(/[^\w-]+/g, '_').slice(0, 40)}_${setKey}.mp4`;
}

const pad = (n) => String(n).padStart(2, '0');

/* Susun slot yang ditick menjadi senarai kerja + kiraan sebab langkau.
   deps: { adalahTarikh, tarikhKeDate, bezaHariIni } — helper tarikh dari
   scheduleV39 (dihantar masuk supaya fail ini bebas daripada import React). */
export function binaRancanganFb({
    isian = {}, kunciJalan, produk, isianServer = null, sekarang = Date.now(),
    caraPost = 'schedule', groupSemasa = 'all', akaunId = '', deps,
}) {
    const { adalahTarikh, tarikhKeDate, bezaHariIni } = deps;
    const rancangan = [];
    const langkauLain = [];
    const kiraan = { tiadaProduk: 0, tiadaVideo: 0, terlepas: 0, lepasHad: 0, salahMinit: 0, luarGroup: 0, jalanLain: 0, kunciRosak: 0 };
    for (const k in isian) {
        const e = isian[k];
        if (!e || !kunciJalan.has(k)) continue;
        const pisah = String(k).split('_');
        const minit = Number(pisah.pop());
        const off = pisah.join('_');
        if (!adalahTarikh(off)) { kiraan.kunciRosak++; continue; }
        /* Sudah dijalankan oleh browser LAIN (corak sama Run TikTok v3.9.2). */
        if (isianServer) {
            const stSv = isianServer[k]?.st;
            if ((stSv === 'running' || stSv === 'complete' || stSv === 'draft') && stSv !== e.st) {
                kiraan.jalanLain++;
                langkauLain.push({ k, st: stSv, sb: isianServer[k]?.sb || '' });
                continue;
            }
        }
        const pid = e.pid || e.p?.id;
        const s = e.s;
        const prod = produk.get(pid);
        if (!prod) { kiraan.tiadaProduk++; continue; }
        if (!prod.prompts?.[s]?.uploadedVideo) { kiraan.tiadaVideo++; continue; }
        if (minit % LANGKAH_MINIT_FB !== 0) { kiraan.salahMinit++; continue; }
        const d = tarikhKeDate(off);
        d.setHours(Math.floor(minit / 60), minit % 60, 0, 0);
        const ms = d.getTime();
        /* Pagar masa HANYA untuk jadual sebenar: "Post sekarang" mengabaikan
           waktu slot, dan draf FB memang tidak boleh membawa waktu (diukur
           12 Sept). */
        if (caraPost === 'schedule') {
            if (bezaHariIni(off) > HAD_HARI_FB) { kiraan.lepasHad++; continue; }
            if (ms - sekarang < HAD_MINIT_FB * 60 * 1000) { kiraan.terlepas++; continue; }
        }
        const grup = prod.workspaceGroup || 'Workspace';
        if (groupSemasa !== 'all' && grup !== groupSemasa) kiraan.luarGroup++; // lapor sahaja — TETAP jalan
        rancangan.push({
            pid, s, ms, k,
            at: `${off}T${pad(Math.floor(minit / 60))}:${pad(minit % 60)}`,
            slotId: `${akaunId}_${off}_${minit}`,
        });
    }
    rancangan.sort((a, b) => a.ms - b.ms);
    return { rancangan, kiraan, langkauLain };
}

/* Payload untuk extension — DIPECAH ikut tanda tangan set (lihat nota ⛔ di
   kepala fail). `shopeeUntuk(prod)` = link Shopee (kad atau My Products) —
   dihantar masuk kerana pencariannya menyentuh Firestore.
   Pulang { tetapan, kumpulan: [{ products, targetSets }], bilReel }. */
export function binaPayloadFb({ rancangan, produk, caraPost, aiLabel = true, shopeeUntuk }) {
    const ikutProduk = new Map();
    const captionKosongSengaja = [];   // ★ 27 Sept — untuk log robot (namaFailReelFb)
    for (const r of rancangan) {
        const prod = produk.get(r.pid);
        if (!prod) continue;
        let entri = ikutProduk.get(r.pid);
        if (!entri) {
            entri = {
                id: prod.id, name: prod.name || '',
                shopeeLink: shopeeUntuk ? (shopeeUntuk(prod) || '') : (prod.shopeeLink || ''),
                videos: {}, captions: {}, jadual: {}, sets: [],
            };
            ikutProduk.set(r.pid, entri);
        }
        const set = prod.prompts?.[r.s] || {};
        entri.videos[r.s] = set.uploadedVideo || '';
        entri.captions[r.s] = captionUntukFb(set);
        if (fbKosongSengaja(set)) {
            const f = namaFailReelFb(entri.name, r.s);
            if (!captionKosongSengaja.includes(f)) captionKosongSengaja.push(f);
        }
        entri.jadual[r.s] = r.at;
        if (!entri.sets.includes(r.s)) entri.sets.push(r.s);
    }
    /* Kumpulkan produk yang set-nya SAMA TEPAT. Susunan kumpulan ikut slot
       terawal supaya robot bermula dengan reel yang waktunya paling hampir. */
    const kumpulanIkutTanda = new Map();
    for (const entri of ikutProduk.values()) {
        entri.sets.sort();
        const tanda = entri.sets.join('|');
        if (!kumpulanIkutTanda.has(tanda)) kumpulanIkutTanda.set(tanda, { products: [], targetSets: [...entri.sets], msAwal: Infinity });
        const kump = kumpulanIkutTanda.get(tanda);
        kump.products.push(entri);
        const awal = Math.min(...rancangan.filter((r) => r.pid === entri.id).map((r) => r.ms));
        if (awal < kump.msAwal) kump.msAwal = awal;
    }
    const kumpulan = [...kumpulanIkutTanda.values()]
        .sort((a, b) => a.msAwal - b.msAwal)
        .map(({ products, targetSets }) => ({ products, targetSets }));
    const mode = caraPost === 'now' ? 'post' : (caraPost === 'draft' ? 'draft' : 'schedule');
    return { tetapan: { mode, aiLabel: aiLabel !== false, captionKosongSengaja }, kumpulan, bilReel: rancangan.length };
}

/* Kunci status pada KAD yang sepadan dengan slot ini. Slot yang dijalankan
   untuk Facebook membawa `pf:'fb'`, untuk telefon `pf:'sp'` (dicop semasa Run); tanpa penanda = TikTok
   (semua slot lama). Effect graduasi + Stop membacanya. */
export function kunciStatusSlot(slot) {
    return `${slot?.pf === 'fb' ? 'fb' : slot?.pf === 'sp' ? 'sp' : 'tiktok'}_${slot?.s}`;
}
